<div class="container flex flex-col justify-start items-start">
    <div class="w-full flex flex-row justify-between items-center">
        <div class="text-xl m-0 font-bold">Izmjena e-maila</div>

        <button mat-icon-button class="self-end" (click)="onClose()">
            <mat-icon> close </mat-icon>
        </button>
    </div>

    <div *ngIf="message" class="mt-3 w-full">{{ message }}</div>

    <div class="mt-3 mb-3 w-full flex flex-col gap-2">
        <mat-form-field>
            <mat-label>Email</mat-label>
            <input matInput type="email" [formControl]="email" />
        </mat-form-field>

        <button class="self-end" mat-flat-button color="primary" (click)="onSubmit()" [disabled]="!email.valid">
            Promijeni
        </button>
    </div>
</div>
